import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table, Select} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined, CopyOutlined} from "@ant-design/icons";
import copy from "copy-to-clipboard";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const ActivityIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [activityPageIndex, setActivityPageIndex] = useState(1);
    const [activityPageSize, setActivityPageSize] = useState(store.main.pageSize);
    const [activityIdList, setActivityIdList] = useState([]);
    const [activityTotal, setActivityTotal] = useState(0);
    const [activityList, setActivityList] = useState([]);
    const [enterpriseList, setProvinceList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/activity/index"});

            handleLoadProvince();

            handleSearchActivity();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadActivity(activityPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadActivity(activityPageIndex, activityPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleLoadProvince = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/enterprise/business/website/v1/select/list",
            data: {},
            success: (response) => {
                setProvinceList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };

    const handleSearchActivity = () => {
        handleLoadActivity(1, activityPageSize);
    };

    const handleLoadActivity = (activityPageIndex, activityPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = activityPageIndex;
        data.pageSize = activityPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/activity/business/website/v1/list",
            data: data,
            success: (response) => {
                setActivityPageIndex(activityPageIndex);
                setActivityPageSize(activityPageSize);
                setActivityIdList([]);
                setActivityTotal(response.data.total);
                setActivityList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddActivity = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/activity/add",
        });
    };

    const handleEditActivity = (activityId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/activity/edit/" + activityId,
        });
    };

    const handleDelActivity = () => {
        if (activityIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/activity/business/website/v1/delete",
                    data: {
                        activityIdList: activityIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setActivityIdList([]);

                        handleLoadActivity(activityPageIndex, activityPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeActivityIdList = (activityIdList) => {
        setActivityIdList(activityIdList);
    };

    const handleChangeActivityPagination = (activityPageIndex, activityPageSize) => {
        handleLoadActivity(activityPageIndex, activityPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddActivity}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={activityIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelActivity}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchActivity}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="企业名称"
                                labelAlign={"left"}
                                name="enterpriseId"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入企业名称",
                                    },
                                ]}
                            >
                                <Select className={Style.card_field} placeholder="请输入企业名称" allowClear onChange={() => {}}>
                                    {enterpriseList.map((enterprise, enterpriseIndex) => {
                                        return (
                                            <Select.Option key={enterpriseIndex} value={enterprise.enterpriseId}>
                                                {enterprise.enterpriseName}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="活动名称"
                                labelAlign={"left"}
                                name="activityName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入活动名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入活动名称" onPressEnter={handleSearchActivity} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.activityId}
                        columns={[
                            {
                                title: "活动名称",
                                dataIndex: "activityName",
                            },
                            {
                                title: "企业名称",
                                dataIndex: "enterpriseName",
                            },
                            {
                                title: "开始日期",
                                dataIndex: "activityStart",
                            },
                            {
                                title: "结束日期",
                                dataIndex: "activityEnd",
                            },
                            {
                                title: "操作",
                                width: 250,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditActivity(record.activityId)}>
                                            修改
                                        </Button>
                                        <Button
                                            icon={<CopyOutlined />}
                                            size="default"
                                            onClick={() => {
                                                copy("https://rewards2.yourright.com.cn/#/activity/index/" + record.activityId);
                                            }}
                                        >
                                            复制H5地址
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={activityList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: activityIdList,
                            onChange: handleChangeActivityIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: activityPageIndex,
                            pageSize: activityPageSize,
                            total: activityTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeActivityPagination,
                            onShowSizeChange: handleChangeActivityPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

ActivityIndex.propTypes = {};

ActivityIndex.defaultProps = {};

export default ActivityIndex;
